import { sendEvent } from "~/app/analytics/ga/ga";

export interface ConfiguratorV2AnalyticsInput {
  productCode: string;
  currentStepNumber: number;
  designation: string;
}

const track = (input: ConfiguratorV2AnalyticsInput, pushContext: string) =>
  sendEvent({
    event: "linearConfigInteraction",
    variant: input.productCode,
    step: input.currentStepNumber,
    push_context: pushContext,
    selection_data: { final_name: input.designation },
  });

export const configuratorV2SummaryAnalytics = {
  requestOffer: (input: ConfiguratorV2AnalyticsInput) => track(input, "request_offer"),
  saved: (input: ConfiguratorV2AnalyticsInput) =>
    track(input, `${input.productCode.toLowerCase()}_configuration_saved`),
  addedToCart: (input: ConfiguratorV2AnalyticsInput) =>
    track(input, `${input.productCode.toLowerCase()}_configuration_added to cart`),
  openedCad: (input: ConfiguratorV2AnalyticsInput) => track(input, "open_CAD_tab"),
};
